import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectToken } from "./utility/Redux/security";

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const token = useSelector(selectToken);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first!");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileKey", `uploads/1234`);

    setUploading(true);
    try {
      axios.post("http://192.168.1.13:5000/api/imageRoute/upload", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch {}
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white shadow-md rounded-lg">
      <h2 className="text-lg font-semibold mb-4">Upload a File</h2>
      <input type="file" onChange={handleFileChange} className="mb-2" />
      <button
        onClick={handleUpload}
        disabled={uploading}
        className="px-4 py-2 bg-blue-500 text-white rounded disabled:bg-gray-400"
      >
        {uploading ? "Uploading..." : "Upload"}
      </button>

      {imageUrl && (
        <div className="mt-4">
          <h3 className="text-md font-medium">Uploaded Image:</h3>
          <img
            src={imageUrl}
            alt="Uploaded"
            className="mt-2 rounded-lg shadow"
          />
          <p className="text-sm text-gray-600 break-all">{imageUrl}</p>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
